package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SignSymptomRelationType(private val literal: String) : IEnumType {
	等同("等同"),
	互斥("互斥");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "sign_symptom_relation_type"}
	override fun getLiteral(): String {return literal}
}
